import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { useActions } from '../store/tickets';


export default /*#__PURE__*/_defineComponent({
  __name: 'button-excel',
  setup(__props) {

const { getTicketsExcel } = useActions(['getTicketsExcel']);
const loading = ref(false)
const excelExport = async () => {
  try {
    loading.value = true;
    const response = await getTicketsExcel();

    // The response data is base64-encoded binary data
    let binaryData = response?.data;

    // If it's a string (base64), decode it
    if (typeof binaryData === 'string') {
      const binaryString = atob(binaryData);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      binaryData = bytes;
    }

    const blob = new Blob([binaryData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const filename = `tickets_${new Date().toISOString().slice(0, 19).replace(/[:.]/g, '-')}.xlsx`;

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a')
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  } catch (error) {
    console.error('Error exporting tickets to Excel:', error);
  } finally {
    loading.value = false;
  }
}

return { __sfc: true,getTicketsExcel, loading, excelExport }
}

})